import { styled } from '@mui/material';

import {
  Bottom as EditorialBottom,
  EditorialMedia,
  Title,
} from '../../../../components/EditorialMedia/EditorialMedia.styles';

export { EditorialMedia as Section, Title };

export const Bottom = styled(EditorialBottom)(({ theme }) => ({
  maxWidth: '100%',
  width: '100%',
  margin: '-120px auto 0',

  [theme.breakpoints.down('2xl')]: {
    margin: '-100px auto 0',
  },
  [theme.breakpoints.down('lg')]: {
    margin: '-80px auto 0',
  },
  [theme.breakpoints.down('md')]: {
    margin: '-70px auto 0',
  },
  [theme.breakpoints.down('sm')]: {
    width: 'calc(100% + 32px)',
    margin: '-24px auto 0',
  },
}));

export const Picture = styled('picture')({
  display: 'block',
  width: '100%',
});

export const Img = styled('img')({
  display: 'block',
  width: '100%',
  height: 'auto',
});
